import { Box, Typography } from '@mui/material';
import { ReactComponent as StudentSelectGuideUserIcon } from 'assets/student-select-guide-user.svg';
import useI18n from 'hooks/useI18n';

/**
 * 교수 메인 — 학생 미선택 시 학생 검색 필드 아래 안내 패널
 */
const StudentSelectGuidePanel = () => {
  const i18n = useI18n();

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: 'absolute',
        top: 'calc(100% + 10px)',
        left: 'auto',
        right: 0,
        zIndex: theme => theme.zIndex.modal + 1,
        width: 'max-content',
        maxWidth: 'min(560px, calc(100vw - 48px))',
        pointerEvents: 'none',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1.5,
          width: 'max-content',
          maxWidth: '100%',
          px: 2,
          py: 1.75,
          borderRadius: '10px',
          bgcolor: '#fff',
          border: '1px solid #C8E4D8',
          boxShadow: '0 8px 24px rgba(23, 71, 54, 0.12)',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: -7,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '7px solid transparent',
            borderRight: '7px solid transparent',
            borderBottom: '7px solid #C8E4D8',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: -5,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderBottom: '6px solid #fff',
          },
        }}
      >
        <Box
          sx={{
            flexShrink: 0,
            width: 40,
            height: 40,
            lineHeight: 0,
            mt: 0.25,
          }}
        >
          <StudentSelectGuideUserIcon
            aria-hidden
            style={{ width: 40, height: 40, display: 'block' }}
          />
        </Box>
        <Box sx={{ flexShrink: 0, pt: 0.25 }}>
          <Typography
            component="p"
            sx={{
              m: 0,
              fontSize: 14,
              fontWeight: 700,
              lineHeight: 1.4,
              color: '#1A1A1A',
              whiteSpace: 'nowrap',
            }}
          >
            {i18n('STUDENT.SELECT.EMPTY.TITLE')}
          </Typography>
          <Typography
            component="p"
            sx={{
              m: 0,
              mt: 0.5,
              fontSize: 12.5,
              fontWeight: 400,
              lineHeight: 1.55,
              color: '#5A5A5A',
              whiteSpace: 'pre',
            }}
          >
            {i18n('STUDENT.SELECT.EMPTY.DESCRIPTION')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default StudentSelectGuidePanel;
